import type { LottieComponentProps } from 'lottie-react';
import { useAsync } from 'react-use';

// Dynamically import `lottie-react` as soon as this module is imported.
const importLottieReactPromise = import('lottie-react').then(
  (module) => module.default
);

export function LottieReact(props: LottieComponentProps) {
  const state = useAsync(() => importLottieReactPromise, []);
  if (state.loading || !state.value) return null;
  const LottieReactModule = state.value;
  return <LottieReactModule {...props} />;
}

// Turbopack returns a frozen ES module namespace from dynamic JSON imports, and
// lottie-web mutates animationData internally (adds `__complete`, layer
// indexes, etc.). Unwrap `.default` and deep-clone so the object is extensible.
export function cloneAnimationData<T = unknown>(data: unknown): T {
  const unwrapped =
    data && typeof data === 'object' && 'default' in data
      ? (data as { default: unknown }).default
      : data;
  return structuredClone(unwrapped) as T;
}
